:host {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  font-family: var(--semantic-typography-font-family-primary), var(--font-fallbacks);
  font-size: wink-rem(1.6);

  .dropdown-menu--heading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var-rem(--semantic-spacing-xs);
    border: 0;
    border-radius: var-rem(--semantic-radius-sm);
    font-family: var(--semantic-typography-font-family-primary), var(--font-fallbacks);
    font-size: var(--wink-dropdown-font-size, inherit);
    color: var(--wink-dropdown-color, var(--semantic-color-text-default));
    text-align: right;
    background-color: var(--wink-dropdown-bg-color, var(--semantic-color-background-surface-subtle-default));

    ::slotted([slot='dropdown-menu--avatar']) {
      margin-right: var-rem(--semantic-spacing-xs);
    }

    .dropdown-menu--chevron {
      transform: rotate(0deg);
      display: inline-flex;
      margin-left: wink-rem(0.8);
      transition: 0.25s ease-in-out;
    }

    &:hover,
    &:focus {
      cursor: pointer;
      background-color: var(--semantic-color-background-surface-subtle-hovered);
    }

    &:focus-visible {
      @include state-focus-outline;
    }
  }

  .dropdown-menu--list {
    --list-space: #{wink-rem(1.8)} 0 0;

    position: absolute;
    z-index: 3;
    display: none;
    min-width: 100%;

    ul {
      display: flex;
      flex-direction: column;
      gap: var-rem(--semantic-spacing-xs);
      margin: var(--list-space);
      padding: var-rem(--semantic-spacing-sm);
      white-space: nowrap;
      background-color: var(--semantic-components-dropdown-background-default);
      box-shadow: 0 wink-rem(0.8) wink-rem(1.6) 0 var(--semantic-elevation-color-color);
      border-radius: var-rem(--semantic-components-dropdown-radius);
    }

    li {
      list-style-type: none;
    }
  }
}

:host([is-expanded]) {
  .dropdown-menu--heading .dropdown-menu--chevron {
    transform: scaleY(-1);
  }

  .dropdown-menu--list {
    display: flex;
  }
}

:host(.dropdown-menu--align-list--top-left) .dropdown-menu--list {
  top: 100%;
  left: 0;
}

:host(.dropdown-menu--align-list--top-right) .dropdown-menu--list {
  top: 100%;
  right: 0;
}

:host(.dropdown-menu--align-list--bottom-left) .dropdown-menu--list {
  --list-space: 0 0 #{wink-rem(1.8)};

  bottom: 100%;
  left: 0;
}

:host(.dropdown-menu--align-list--bottom-right) .dropdown-menu--list {
  --list-space: 0 0 #{wink-rem(1.8)};

  right: 0;
  bottom: 100%;
}

:host(.dropdown-menu--align-list--top-center) .dropdown-menu--list {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
}

:host(.dropdown-menu--align-list--bottom-center) .dropdown-menu--list {
  --list-space: 0 0 #{wink-rem(1.8)};
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
}
